<template>
	<button
		class="card"
		@click="$emit('editItem')"
		@keyup.enter="$emit('editItem')"
		@keyup.space="$emit('editItem')"
		:aria-label="name"
	>
		<div class="link">
			<div v-if="image.imageUrl" class="image-wrapper">
				<img class="image" :src="image.imageUrl" :alt="image.imageAlt" />
			</div>
			<div class="content">
				<div class="main-content">
					<h3 class="title">{{ name }}</h3>
					<p v-if="description" class="description">
						{{ formatItemDescription(description) }}
					</p>
				</div>
				<div class="footer">
					<div v-if="price" class="price">${{ price.toFixed(2) }}</div>
					<div v-if="isAlcohol" class="alcohol-indicator">
						<span class="cart-button-text"> Alcohol </span>
					</div>
					<div class="icons-section-wrapper">
						<icon-base
							v-for="icon in allergyIcons"
							:key="icon"
							height="20"
							width="20"
							class="icon"
							:iconName="icon"
						>
							<component :is="icon" />
						</icon-base>
					</div>
				</div>
			</div>
		</div>
	</button>
</template>

<script>
import IconBase from "./IconBase.vue";
import IconCarrot from "./icons/IconCarrot.vue";
import IconGF from "./icons/IconGF.vue";
import IconSpicy from "./icons/IconSpicy.vue";
import IconV from "./icons/IconV.vue";

export default {
	name: "MenuCard",
	components: {
		IconBase,
		IconCarrot,
		IconGF,
		IconSpicy,
		IconV,
		IconBase,
	},
	props: {
		name: String,
		price: Number,
		description: String,
		image: {
			type: Object,
			default: () => {},
		},
		allergyIcons: {
			type: Array,
			default: () => [],
		},
		vegetarian: {
			type: Boolean,
			default: false,
		},
		vegan: {
			type: Boolean,
			default: false,
		},
		glutenFree: {
			type: Boolean,
			default: false,
		},
		spicy: {
			type: Boolean,
			default: false,
		},
		isAlcohol: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		formatItemDescription(description) {
			if (this.image.imageUrl) {
				if (description.length >= 96) {
					return description.slice(0, 96).trim() + "...";
				} else {
					return description;
				}
			} else if (description.length >= 155) {
				return description.slice(0, 155).trim() + "...";
			}
			return description;
		},
	},
};
</script>

<style lang="scss" scoped>
.card {
	@include card-wrapper;
	height: 100%;
	text-align: left;
}

.link {
	display: flex;
	width: 100%;
	text-decoration: none;
	cursor: pointer;
}

.image-wrapper {
	position: relative;
	min-height: 125px;
	flex: 0 0 125px;
}

.image {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	object-fit: cover;
	border-radius: $border-radius;
}

.content {
	flex: 1 1 auto;
	padding: 10px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	font-size: 1.4rem;
}

.main-content {
	display: flex;
	flex-direction: column;
	margin-bottom: 15px;
	overflow-y: hidden;
}

.title {
	font-weight: 900;
	line-height: 1.53;
	text-align: left;
}

.footer {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.icons-section-wrapper {
	display: flex;
}

.description {
	line-height: 1.4;
}

.price {
	font-weight: 700;
}

.icon {
	color: #0184c6;
}

.alcohol-indicator {
	font-size: 14px;
	font-weight: 700;
	text-align: center;
	padding: 5px !important;
	background-color: #ffd71b !important;
	border-radius: 22.5px;
	box-shadow: 1px 1px 5px 0 rgba(171, 168, 168, 0.5);
	white-space: nowrap;
	margin-left: auto;
}
</style>